export const MESSAGE_LIST_WIDGET_LIMIT = 1000;
// This timezone will be used when a report has no time zone.
export const REPORT_TZ_FALLBACK = 'UTC';
